<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-gis.svg" can-back-flag="1"></Header>
    </header>

    <!--一覧-->
    <div id="wrapper">
      <div class="content">
        <a href="../webgis_howto/index.html" target="_blank" rel="noopener" class="btn-gis-use">●使い方</a>
        
        <div class="gis-list-box">
          <h3 class="ttl">第１部 第１章　地図と地理情報システム</h3>
          <ul>
            <li v-for='row in rows1' v-bind:key='row.id'>
              <a :href="row.url" target="_blank" rel="noopener"><img :src="row.image" :alt="row.title"></a>
            </li>
          </ul>
        </div>

        <div class="gis-list-box">
          <h3 class="ttl">第２部 第１章　生活文化の多様性と国際理解</h3>
          <ul>
            <li v-for='row in rows2' v-bind:key='row.id'>
              <a :href="row.url" target="_blank" rel="noopener"><img :src="row.image" :alt="row.title"></a>
            </li>
          </ul>
        </div>

        <div class="gis-list-box">
          <h3 class="ttl">第３部 第１章　自然環境と防災</h3>
          <ul>
            <li v-for='row in rows3' v-bind:key='row.id'>
              <a :href="row.url" target="_blank" rel="noopener"><img :src="row.image" :alt="row.title"></a>
            </li>
          </ul>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  mounted: function () {

    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-his")
    $("body").addClass("page-his-links-index")
    cmd.adjustStyle()

    this.search()
  },
  methods: {
    ...mapActions('WebGisModule', {
      'prevAction': 'prevAction',
      'search': 'search',
      'showDetail': 'showDetail',
    }),
    linkAction (e) {
      var element = e.currentTarget
      var id = element.getAttribute('id')
      this.showDetail(id)
    }
    
  },
  computed: {    
    ...mapGetters('WebGisModule', [
      'rows1',
      'rows2',
      'rows3',
    ])
  },
  components: {
    Header
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/WebGisList.vue